import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=ce8d9c60&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=ce8d9c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8d9c60",
  null
  
)

export default component.exports